// recorderBridge.js
// Decouples agent tools from whichever recorder component is mounted
// (MultiRecorder view, extension Recorder, MinimalFloatingUI). The recorder
// registers its actions on mount (actionsRef pattern, see SYNAPSE.md) and the
// agent calls through this bridge.
import { Emitter } from './events';

const events = new Emitter();
let actions = null; // { startRecording(ids), stopRecording(), getRecordingIds() }

export const registerRecorderActions = (recorderActions) => {
  actions = recorderActions;
  events.emit('registered', true);
  return () => {
    if (actions === recorderActions) actions = null;
    events.emit('registered', false);
  };
};

export const recorderAvailable = () => Boolean(actions);

export const onRecorderChange = (cb) => events.on('registered', cb);

export const startRecording = async (conversationIds) => {
  if (!actions?.startRecording) {
    return { error: 'No recorder is available on this screen yet.' };
  }
  return actions.startRecording(conversationIds);
};

export const stopRecording = async (conversationIds) => {
  if (!actions?.stopRecording) {
    return { error: 'No recorder is available on this screen yet.' };
  }
  return actions.stopRecording(conversationIds);
};

export const getRecordingIds = () => actions?.getRecordingIds?.() || [];
